<template>
  <div>
    <h1 class="text-4xl font-bold">{{ _('cookies.intro.title') }}</h1>

    <p class="my-8">
      {{ _('cookies.intro.text') }}
    </p>

    <div class="grid grid-cols-2 gap-6">
      <button
        id="cookie-popup-acceptbasic"
        @click="acceptBasic()"
        type="button"
        class="bg-gray-300 text-black uppercase font-bold rounded lg:px-12 md:px-8 sm:px-6 py-3"
      >
        {{ _('cookies.btn.accept_basic') }}
      </button>

      <button
        id="cookie-popup-acceptall"
        @click="acceptAll()"
        type="button"
        class="bg-orange text-white uppercase font-bold rounded lg:px-12 md:px-8 sm:px-6 py-3"
      >
        {{ _('cookies.btn.accept_all') }}
      </button>
    </div>

    <div class="text-center mt-10">
      <button
        id="cookie-popup-settings"
        type="button"
        class="link-btn text-base font-bold"
        @click="$emit('openSettings')"
      >
        {{ _('cookies.btn.open_settings') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },

  methods: {
    acceptBasic() {
      this.$emit('write', {
        necessary: true,
        preferences: false,
        performance: true,
        functional: false
      });
    },

    acceptAll() {
      this.$emit('write', {
        necessary: true,
        preferences: true,
        performance: true,
        functional: true
      });
    },

    _(key) {
      return this.data[key];
    }
  }
};
</script>
